export default "__VITE_ASSET__C56u9THB__"